import React, { Component } from 'react';
import theme from '../theme';
import { RESIZE_TIMOUT } from '../../lib/constants';

// TODO: Add helper function to check if isMobile on server side by checking userAgent
class MediaQueryHelper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: Infinity,
    };

    this.getAndSetWidth = this.getAndSetWidth.bind(this);
    this.timer = null;
  }

  componentDidMount() {
    this.getAndSetWidth();
    if (window) {
      window.addEventListener('resize', this.onResizeEvent);
    }
  }

  onResizeEvent = () => {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.getAndSetWidth();
    }, RESIZE_TIMOUT);
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this.onResizeEvent);
    }
  }

  getAndSetWidth() {
    if (document && window) {
      const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

      this.setState({
        width,
      });
    }
  }

  render() {
    const {
      desktopChildren,
      mobileChildren,
    } = this.props;

    const deviceBreakpoint = theme.breakpoints.m[0];
    const isMobile = (this.state.width < deviceBreakpoint);

    const childrenToRender = isMobile ? mobileChildren : desktopChildren;

    return childrenToRender;
  }
}

// MediaQueryHelper used for smaller desktop screens to large
// Used by component CategoriesMenuBar
export class MediaQueryHelperDesktop extends MediaQueryHelper {
  render() {
    const {
      desktopChildren,
      smallDesktopChildren,
    } = this.props;

    const deviceBreakpoint = theme.breakpoints.l[0];
    const isSmallDesktop = (this.state.width < deviceBreakpoint);

    const childrenToRender = isSmallDesktop ? smallDesktopChildren : desktopChildren;

    return childrenToRender;
  }
}

export default MediaQueryHelper;
